module.exports = __webpack_public_path__ + "fonts/Avenir-HeavyOblique.a85b1fc.woff2";